import React from "react";
import Hero from "../../components/hero/Hero";
import ExploreWork from "../../components/exploreWork/ExploreWork";
import AboutSec from "../../components/aboutSec/AboutSec";
import ServicesSec from "../../components/servicesSec/ServicesSec";
import Progress from "../../components/progress/Progress";
import Faqs from "../../components/faqs/Faqs";

const Home = () => {
  return (
    <>
      <Hero />
      <ExploreWork />
      <AboutSec />
      <ServicesSec />
      <Progress />
      <Faqs />
    </>
  );
};

export default Home;
